import axios from 'axios'

export const state = {
  reportData: {},
  initialData: [],
}

export const getters = {
  getReportData() {
    return state.reportData
  },
  getReportInitialData() {
    return state.initialData
  },
}

export const mutations = {
  SET_REPORT_DATA(state, data) {
    state.reportData = data
  },
  CLEAR_REPORT_DATA(state) {
    state.reportData = {}
  },
  SET_INITIAL_DATA(state, data) {
    state.initialData = data
  },
}

export const actions = {
  fetchReport({
    commit
  }, {
    baseReportUrl,
    params
  }) {
    commit('CLEAR_REPORT_DATA')
    return axios
      .get(`v1/${baseReportUrl}/`, {
        params: params
      })
      .then(response => {

        if (response.data === '') {} else {
          commit('SET_REPORT_DATA', response.data)
        }

        return response.data
      })
      .catch(error => {
        return error
      })
  },

  clearReportData({
    commit
  }) {
    commit('CLEAR_REPORT_DATA')
  },

  setReportInitialData({
    commit
  }, data) {
    commit('SET_INITIAL_DATA', data)
  },

  setReportData({
    commit
  }, data) {
    commit('SET_REPORT_DATA', data)
  },

  fetchOutletRelatedData({
    commit
  }, outletId) {
    return axios.get(`/v1/outlets/${outletId}`).then(response => {
      let currentOutletData = response.data
      currentOutletData.id = outletId
      commit('SET_INITIAL_DATA', currentOutletData)
      return currentOutletData
    })
  },
}
